$(function(){
    $('.b-partners-forms').each(function(){
        var $context = $(this),
            $form = $('form', $context);

        $form.on('submit', function(){
            $("html, body").animate({
                scrollTop: $context.offset().top - 160
            }, 1e3)
        })
    })
})